module.exports = __webpack_public_path__ + "85b2837ec1ce234fa8b82126577c72d2.png";